import React from 'react';
import { motion } from 'framer-motion';
import { Clock, ShoppingCart, Droplets, Hand, Zap, BoxIcon } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: Clock,
    title: 'Sesión de 90 minutos',
    desc: 'El paso a paso exacto: qué prender primero, qué va después, cómo no perder tiempo.'
  }, {
    icon: ShoppingCart,
    title: 'La Lista Fija',
    desc: 'Núcleo + opcionales para que comprar sea automático.'
  }, {
    icon: BoxIcon,
    title: 'Matriz de 12 Combos',
    desc: 'Bowls, wraps, ensaladas, calientes para no aburrirte.'
  }, {
    icon: Droplets,
    title: '6 Salsas Salvavidas',
    desc: 'Listas en 2 minutos para que la comida tenga ganas de ser comida.'
  }, {
    icon: Hand,
    title: 'Porciones sin obsesión',
    desc: 'Método “mano” para comer normal sin “modo dieta”.'
  }, {
    icon: Zap,
    title: 'Plan Rescate en 10 min',
    desc: 'Para semanas caóticas (porque van a pasar).'
  }];
  return <section className="py-24 px-6 bg-warm-50" data-id="element-101">
      <div className="max-w-5xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-103">
          <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-4 font-display" data-id="element-104">
            LO QUE INCLUYE EL EBOOK
          </h2>
          <p className="text-lg text-warm-900/70" data-id="element-105">
            Proteína Lista (sin pensar) es un PDF directo y práctico.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-106">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start p-6 bg-white rounded-xl shadow-sm border border-warm-100 hover:shadow-md transition-shadow" data-id="element-107">
              <div className="bg-teal-50 p-3 rounded-lg mr-5 text-teal-600 flex-shrink-0" data-id="element-108">
                <item.icon size={24} data-id="element-109" />
              </div>
              <div data-id="element-110">
                <h3 className="text-lg font-bold text-warm-900 mb-2" data-id="element-111">
                  {item.title}
                </h3>
                <p className="text-warm-900/70 leading-relaxed" data-id="element-112">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}